
// @ts-nocheck
import locale__opt_buildhome_repo_locales_de_json from "../locales/de.json";
import locale__opt_buildhome_repo_locales_en_json from "../locales/en.json";
import locale__opt_buildhome_repo_locales_nl_json from "../locales/nl.json";


export const localeCodes =  [
  "de",
  "en",
  "nl"
]

export const localeLoaders = {
  "de": [{ key: "../locales/de.json", load: () => Promise.resolve(locale__opt_buildhome_repo_locales_de_json), cache: true }],
  "en": [{ key: "../locales/en.json", load: () => Promise.resolve(locale__opt_buildhome_repo_locales_en_json), cache: true }],
  "nl": [{ key: "../locales/nl.json", load: () => Promise.resolve(locale__opt_buildhome_repo_locales_nl_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "de",
      "files": [
        "/opt/buildhome/repo/locales/de.json"
      ]
    },
    {
      "code": "en",
      "files": [
        "/opt/buildhome/repo/locales/en.json"
      ]
    },
    {
      "code": "nl",
      "files": [
        "/opt/buildhome/repo/locales/nl.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "de",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/de.json"
      }
    ]
  },
  {
    "code": "en",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/en.json"
      }
    ]
  },
  {
    "code": "nl",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/nl.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
